export default __webpack_public_path__ + "static/avatar-2-fa6512f0f988597489c61e1dde759648.jpg";